import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    data: []
};
export var DashboardAlgorithmsReducer = createSlice({
    name: 'dashboardAlgorithms',
    initialState: initialState,
    reducers: {
        setDashboardAlgorithms: function setDashboardAlgorithms(state, action) {
            state.data = action.payload;
        }
    }
});
var setDashboardAlgorithms = DashboardAlgorithmsReducer.actions.setDashboardAlgorithms;
export { setDashboardAlgorithms };
export default DashboardAlgorithmsReducer.reducer;
